module.exports = __webpack_public_path__ + "img/motorcycle-green.7f40b8d3.svg";